import type { Video, VideoCategory, VideosResponse } from "src/components/videos/types";
import { api } from "./api-client.config";

// Video Category API
export const createVideoCategory = async (name: string): Promise<VideoCategory> => {
	return api.post("/video/category", { name });
};

export const updateVideoCategory = async (categoryId: number, name: string): Promise<VideoCategory> => {
	return api.put(`/video/category/${categoryId}`, { name });
};

export const deleteVideoCategory = async (categoryId: number): Promise<void> => {
	return api.delete(`/video/category/${categoryId}`);
};

export const getVideoCategories = async (): Promise<VideoCategory[]> => {
	return api.get("/video/categories");
};

// Video API
export const createVideo = async (video: Omit<Video, "video_id">): Promise<Video> => {
	return api.post("/video", video);
};

export const updateLivestream = async (videoId: number, video: Partial<Video>): Promise<Video> => {
	return api.put(`/livestream/${videoId}`, video);
};

export const updateVideo = async (videoId: number, video: Partial<Video>): Promise<Video> => {
	return api.put(`/video/${videoId}`, video);
};

export const deleteVideo = async (videoId: number): Promise<void> => {
	return api.delete(`/video/${videoId}`);
};

export const getAllVideos = async (): Promise<VideosResponse> => {
	return api.get("/videos");
};

export const getVideosByCategory = async (categoryId: number): Promise<VideosResponse> => {
	return api.get(`/videos/category/${categoryId}`);
};

export const importFullVideoList = async (data: { livestream: Video; videos: Video[] }): Promise<VideosResponse> => {
	return api.post("/videos/import", data);
};
